"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemotePinApi = void 0;
const common_1 = require("@ceramicnetwork/common");
class RemotePinApi {
    constructor(_apiUrl) {
        this._apiUrl = _apiUrl;
    }
    async add(streamId, force) {
        const args = {};
        if (force) {
            args.force = true;
        }
        await common_1.fetchJson(this._apiUrl + '/pins' + `/${streamId.toString()}`, {
            method: 'post',
            body: args,
        });
    }
    async rm(streamId, opts) {
        await common_1.fetchJson(this._apiUrl + '/pins' + `/${streamId.toString()}`, {
            method: 'delete',
            body: { opts },
        });
    }
    async ls(streamId) {
        let url = this._apiUrl + '/pins';
        if (streamId) {
            url += `/${streamId.toString()}`;
        }
        const result = await common_1.fetchJson(url);
        const { pinnedStreamIds } = result;
        return {
            [Symbol.asyncIterator]() {
                let index = 0;
                return {
                    next() {
                        if (index === pinnedStreamIds.length) {
                            return Promise.resolve({ value: null, done: true });
                        }
                        return Promise.resolve({ value: pinnedStreamIds[index++], done: false });
                    },
                };
            },
        };
    }
}
exports.RemotePinApi = RemotePinApi;
//# sourceMappingURL=remote-pin-api.js.map